<template>
  <div :style="{ height: `${space}px` }"></div>
</template>

<script>
export default {
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      space: 0
    };
  },
  created() {
    this.space = this.slice.primary?.space;
  }
};
</script>

<style></style>
